import React, { useState } from 'react';
const UserContext = React.createContext({
  userRole: '',
  userName: '',
  // userControl: "",
  // userLastLoginTime: "",
  // userRefreshToken: "",
  // organisationid: "",
  setUserRole: () => {},
  setUserName: () => {},
  // setUserControl: () => {},
  // setUserLastLoginTime: () => {},
  // setUserRefreshToken: () => {},
  // setorgid: () => {},
});
const retrieveStoredData = () => {
  const storedRole = sessionStorage.getItem('Role');
  const storedName = sessionStorage.getItem('Name');
  // const storedControl = sessionStorage.getItem("Control");
  // const storedLastLoginTime = sessionStorage.getItem("LasLoginTime");
  // const storeduserId = sessionStorage.getItem("organisationid");

  return {
    userName: storedName,
    userRole: storedRole,
    // userControl: storedControl,
    // userLastLoginTime: storedLastLoginTime,
    // organisationid: storeduserId,
  };
};
export const UserContextProvider = props => {
  const storedData = retrieveStoredData();
  var initialRole;
  var initialName;
  // var initialControl;
  // var initialLastLoginTime;
  // var initialuserId;

  if (storedData) {
    initialRole = storedData.userRole;
    initialName = storedData.userName;
    // initialControl = storedData.userControl;
    // initialLastLoginTime = storedData.userLastLoginTime;
    // initialuserId = storedData.organisationid;
  }
  const [userRole, setUserRole] = useState(initialRole);
  const [userName, setUserName] = useState(initialName);
  // const [userControl, setUserControl] = useState(initialControl);
  // const [organisationid, setorgid] = useState(initialuserId);

  // const [userLastLoginTime, setUserLastLoginTime] =
  //   useState(initialLastLoginTime);

  const userRoleHandler = userRole => {
    setUserRole(userRole);
    sessionStorage.setItem('Role', userRole);
  };
  const userNameHandler = userName => {
    setUserName(userName);
    sessionStorage.setItem('Name', userName);
  };
  // const userLastLoginTimeHandler = (userLastLoginTime) => {
  //   setUserLastLoginTime(userLastLoginTime);
  //   sessionStorage.setItem("LastLoginTime", userLastLoginTime);
  // };
  // const userNameHandler = (userName) => {
  //   setUserName(userName);
  //   sessionStorage.setItem("Name", userName);
  // };
  // const userControlHandler = (userControl) => {
  //   setUserControl(userControl);
  //   sessionStorage.setItem("control", userControl);
  // };

  // const orgidHandler = (organisationid) => {
  //   setorgid(organisationid);
  //   sessionStorage.setItem("organisationid", organisationid);
  // };

  const contextValue = {
    userRole: userRole,
    userName: userName,
    // userControl: userControl,
    // userLastLoginTime: userLastLoginTime,
    // organisationid: organisationid,

    setUserRole: userRoleHandler,
    setUserName: userNameHandler,
    // setUserControl: userControlHandler,
    // setUserLastLoginTime: userLastLoginTimeHandler,
    // setorgid: orgidHandler,
  };
  return (
    <UserContext.Provider value={contextValue}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;
